import React, { FC } from 'react'
import { useQuery } from '@apollo/client'

import { MenuItemModal } from '../OutletMenu/MenuItemModal/MenuItem.modal'
import { BottomSheetWrapper } from '@src/components/BottomSheetWrapper/BottomSheetWrapper'

import { useMenuItemQueryParam } from '@src/hooks/useMenuItemQueryParam'
import { GetOutletMenuItemDocument } from '../OutletMenu/MenuItem/queries/__generated__/GetOutletMenuItem.graphql-interface'

type OutletBottomSheetProps = {
  outletId: string
}

export const OutletBottomSheet: FC<OutletBottomSheetProps> = ({ outletId }) => {
  const [modalMenuItemId, setMenuItemQueryParam] = useMenuItemQueryParam()

  const { data } = useQuery(GetOutletMenuItemDocument, {
    variables: { outletId, menuItemId: modalMenuItemId ?? '' },
    skip: !modalMenuItemId,
  })

  return (
    <BottomSheetWrapper
      open={!!modalMenuItemId}
      onClose={() => setMenuItemQueryParam(undefined, 'replaceIn')}
      headerColor="#fff"
      backgroundColor="#fff"
    >
      {data && (
        <MenuItemModal
          outletMenuItem={data.outletMenuItem}
          closeModal={() => setMenuItemQueryParam(undefined, 'replaceIn')}
        />
      )}
    </BottomSheetWrapper>
  )
}
